<template>
  <div class="login-normal-container">
    <form name="form.forgotPassword" class="first-login-container" @submit.prevent="passwordRequest()">
      <!-- Errors Alert anchor -->
      <div class="errors">
        <div ref="alert"></div>
      </div>
      
      <div class="password-forgot-title">{{ $t("message.login_request_password_title") }}</div>
      
      <div class="form-login-container">
        <!-- Email field -->
        <div class="form-group-modern">
          <label class="label-modern" for="m_email">{{ $t('message.ei_titleList_text_2_2') }}</label>
          <div class="input-wrapper-modern">
            <input 
              type="text" 
              id="m_email" 
              name="mail" 
              v-model="form.forgotPassword.mail"
              v-validate="'required|email'" 
              data-vs-input="input-forget-pass-mail"
              class="input-modern"
              placeholder="Ingrese su correo electrónico"
              autocomplete="email"
            />
          </div>
          <span class="error-message-modern" v-show="errors.has('mail')">
            {{ errors.first('mail') }}
          </span>
        </div>

        <!-- User field -->
        <div class="form-group-modern">
          <label class="label-modern" for="m_usuario">{{ $t('message.login_text_user') }}</label>
          <div class="input-wrapper-modern">
            <input 
              type="text" 
              id="m_usuario" 
              name="usuario" 
              v-model="form.forgotPassword.user"
              v-validate="{ required: true, regex: /^[a-zA-Z0-9_]{1,32}$/ }" 
              data-vs-input="input-forget-pass-user"
              class="input-modern"
              placeholder="Ingrese su usuario"
              autocomplete="username"
            />
          </div>
          <span class="error-message-modern" v-show="errors.has('usuario')">
            {{ errors.first('usuario') }}
          </span>
        </div>

        <!-- Action Buttons -->
        <div class="first-login-buttons-container forgot-buttons">
          <button 
            type="button" 
            id="m_login_forget_password_cancel" 
            class="btn-modern btn-cancel-modern"
            data-vs-button="button-forget-pass-auth-login" 
            @click="clickAuthLogin"
          >
            {{ $t('message.login_go_back') }}
          </button>

          <button 
            v-if="buttonLoginDisable" 
            type="submit" 
            id="m_login_forget_password_submit" 
            class="btn-modern btn-submit-modern"
            :disabled="form.invalid"
          >
            {{ $t('message.login_send') }}
          </button>
          
          <button 
            v-else 
            type="button" 
            id="m_login_forget_password_submit" 
            class="btn-modern btn-submit-modern btn-loading-modern"  
            disabled
          >
            Cargando...
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Vue } from "vue-property-decorator";
import User from "../../apiClient/User";
import Alert from "../../components/generics/Alert.vue";

export default {
  components: {
    Alert
  },
  data(){
    return{
      reCaptchaKey: '',
      gReCaptchaResponse: '',
       form: {
        forgotPassword: {
          mail: '',
          user: ''
        }
      },
      buttonLoginDisable: true,
      baseUrl: process.env.VUE_APP_BASE
    }
  },
  created(){
    this.user = new User();
  },
  methods:{
    clickAuthLogin(){
      this.$emit('clickAuthLogin', true)
    },
    resetForm(){
      this.form.forgotPassword.mail = '';
      this.form.forgotPassword.user = '';
    },
    passwordRequest() {
      this.alertMoment = JSON.parse(localStorage.getItem("alertMoment"));
      this.$validator.validate().then( async result => {
        if (result) {
          this.changeStateReload();
          await this.$recaptchaLoaded()
          await this.$recaptcha('login')
          await this.user.resetPassRequest(this.form.forgotPassword.user, this.form.forgotPassword.mail)
            .then(result => {
              if (result.status === 200) {
                swal({
                  type: "success",
                  title: this.$t('message.login.forgot_password'),
                  showConfirmButton: true,
                  confirmButtonText: "Aceptar"
                }).then(result => {
                  this.resetForm();
                  this.$emit('clickAuthLogin', true)
                });
              } else {
                if (this.alertMoment) {
                  this.errorMessage(this.$t('message.login.err404ForgotPass'));
                }
              }
            })
            .catch(e => {
              if (this.alertMoment) {
                this.errorMessage(this.$t('message.login.err404ForgotPass'));
              }
              this.changeStateReload();
            });
        }
      });
    },
    errorMessage(msg){
      const ComponentClass = Vue.extend(Alert)
      const instance = new ComponentClass({propsData: { role: 'danger', title: 'Error', message: this.$t(msg) }}).$mount();
      this.$refs.alert.appendChild(instance.$el);
    },
    changeStateReload(){
      this.buttonLoginDisable = !this.buttonLoginDisable;
    },
    onVerify(gRecaptchaResponse) {
      this.gReCaptchaResponse = gRecaptchaResponse;
    }
  }
}
</script>

<style scoped lang="scss">
  @import "./login.scss";
  @import "./login-modern.scss";
  .swal2-popup .swal2-content{
      font-size: 1.6em !important;
  }
</style>
